module.exports = __webpack_public_path__ + "img/servive_rencai.d39cdb45.jpg";